import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    http.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const off = () => setUser(false);
    window.addEventListener("auth:expired", off);
    return () => window.removeEventListener("auth:expired", off);
  }, []);
  const logout = async () => { await http.post("/auth/logout").catch(() => {}); setUser(false); };
  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
};
